import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import ProcesosTopSection from 'components/modules/project-management/ProcesosTopSection';
import PagosSueldosListTable, {
  pagosSueldosListTableColumns
} from 'components/tables/PagosSueldosListTable';
import { defaultBreadcrumbItems } from 'data/commonData';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useState, useEffect } from 'react';
import { useAuth } from 'providers/AuthProvider';

const PagosSueldosListView = () => {
  const [pagosSueldos, setpagosSueldos] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:2000'; 


  useEffect(() => {
    const fetchPagosSueldos = async () => {
      try {
        const response = await axios.get(`${apiUrl}/pagosSueldos/`);
        const data = await response.data;
        setpagosSueldos(data);
      } catch (error) {
        console.error('ha habido un error: ', error);
      }
    };
    fetchPagosSueldos();
  });

  const table = useAdvanceTable({
    data: pagosSueldos,
    columns: pagosSueldosListTableColumns,
    pageSize: 2400,
    pagination: true,
    sortable: true
  });

  return (
    <div>
      <AdvanceTableProvider {...table}>
        <div className="d-flex flex-wrap mb-4 gap-3 gap-sm-6 align-items-center">
          <h2 className="mb-0">
            <span className="me-3">Pagos De Sueldos</span>{' '}
            <span className="fw-normal text-body-tertiary"></span>
          </h2>
          <Link className="btn btn-primary px-5" to="/apps/pagos/createpagoSueldo">
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            Agregar Nuevo
          </Link>
        </div>
        <ProcesosTopSection activeView="list" />
        <PagosSueldosListTable />
      </AdvanceTableProvider>
    </div>
  );
};

export default PagosSueldosListView;
